import InteractionsChart from "./InteractionsChart";

export default InteractionsChart